// src/pages/Notebooks/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "../Collectionpage";
import { getNotebooks, PRODUCTS_PER_PAGE } from "../../data/notebooks";
import SEOHead from "../../components/common/SEOHead";
import ProductListSchema from "../../components/common/ProductListSchema";
import FAQSchema from "../../components/common/FAQSchema";

const PAGE_URL = "https://aishcraft.com/notebooks";

const notebookFAQs = [
  {
    question: "What paper types are available for notebooks?",
    answer: "Our notebooks are available in lined, dotted, and plain paper — smooth, fountain-pen friendly, and premium quality.",
  },
  {
    question: "Can I personalize the cover with my name?",
    answer: "Yes, every notebook can be customized with your name, initials, or a custom design on the cover.",
  },
  {
    question: "How long does delivery take?",
    answer: "Personalized notebooks are made to order and typically ship within 6 working days across India.",
  },
];

export default function Notebooks() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getNotebooks()
      .then(setProducts)
      .catch((err) => setError(err.message || "Failed to load products"));
  }, []);

  const seo = (
    <SEOHead
      title="Notebooks | Personalized Lined, Dotted & Plain Notebooks"
      description="Shop 300+ beautifully designed personalized notebooks — lined, dotted & plain. Premium fountain-pen friendly paper, pan India delivery."
      url={PAGE_URL}
      breadcrumbs={[
        { name: "Home", item: "https://aishcraft.com/" },
        { name: "Notebooks", item: PAGE_URL },
      ]}
    />
  );

  if (error) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>
      </>
    );
  }

  if (!products) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>
      </>
    );
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/notebooks",
    announcement: {
      headline: "New Notebooks — Lined, Dotted & Plain!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Notebooks",
      subtitle: "Every idea, beautifully kept",
      featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "The paper quality is incredible — smooth, fountain-pen friendly and absolutely gorgeous.",
      quoteLink: "#",
      rating: "4.8",
      ratingCount: "1000+",
    },
  };

  return (
    <>
      {seo}
      <ProductListSchema products={products} pageUrl={PAGE_URL} />
      <FAQSchema faqs={notebookFAQs} />
      <CollectionPage config={config} />
    </>
  );
}